/**
 * Mock API Registry
 *
 * Each entry defines a mock route that the MockApiInterceptor will match against
 * outgoing HTTP requests. When a match is found, the interceptor returns the canned
 * response instead of hitting the network.
 *
 * Post-session, this file serves as a machine-readable API contract: backend developers
 * can read each entry to understand the URL pattern, HTTP method, and expected response
 * shape the UI requires. Remove entries as real endpoints are deployed.
 */

export interface MockRoute {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  urlPattern: string | RegExp;
  status: number;
  description: string;
  response: unknown;
  delay?: number;
}

export const MOCK_ROUTES: MockRoute[] = [
  // Add mock routes during prototyping sessions. Example:
  //
  // {
  //   method: 'GET',
  //   urlPattern: /\/api\/opportunities\/.*\/risk-summary$/,
  //   status: 200,
  //   description: 'Returns risk assessment summary for an opportunity',
  //   response: {
  //     riskScore: 72,
  //     factors: [
  //       { name: 'LVR', score: 85, weight: 0.3 },
  //       { name: 'Income Stability', score: 65, weight: 0.25 }
  //     ],
  //     recommendation: 'Refer'
  //   },
  //   delay: 300
  // }
];
